import React, { useState } from 'react'

import { Context } from 'types/GlobalUserEvents'
import { TResource } from 'types/GlobalResource'

import { useAccountSettings } from 'redux/hooks/SignedInAccount'
import { useDashboardGroupActions } from 'redux/actions/DashboardGroups'
import { useDashboardGroupsInGroup } from 'redux/hooks/DashboardGroups'
import { useGroup, useIsOwner } from 'redux/hooks/Groups'
import { useParams, useResources } from 'utils/hooks'
import { useTranslation } from 'language/translator'

import SectionHeader from 'components_new/molecules/SectionHeader'

import ResourcesTable from 'components_new/organisms/ResourcesTable'
import UnlinkDialog from 'components_new/organisms/dialogs/UnlinkDialog'

import GroupTemplate from 'components_new/templates/GroupTemplate'

import Empty from './empty'

const GroupResources = () => {
  const { id } = useParams<{ id: string }>()
  const group = useGroup(id)
  const { t } = useTranslation()

  const isOwner = useIsOwner(id)
  const { isAdmin } = useAccountSettings()

  const { tryRevokeFromDashboard } = useDashboardGroupActions()

  const dashboardGroups = useDashboardGroupsInGroup(id)
  const resources = useResources({
    dashboardGroups,
    reports: [] // $ TODO
  })

  const [dialog, setDialog] = useState<{
    data: { id: string; title: string } | null
    open: boolean
    variant: 'unlink'
  }>({ data: null, open: false, variant: 'unlink' })

  const handleUnlink = (resource: TResource) => {
    setDialog((prevState) => ({
      ...prevState,
      data: { id: resource.id, title: resource.title },
      open: true,
      variant: 'unlink'
    }))
  }

  const handleCloseDialog = () => {
    setDialog((prevState) => ({
      ...prevState,
      open: false
    }))
  }

  return (
    <>
      <GroupTemplate
        subpage={{
          icon: { name: 'Resources' },
          title: t('global', 'resources')
        }}
        variant="static"
      >
        <SectionHeader
          gutterBottom={true}
          size="large"
          title={t('global', 'resources')}
        />

        {dashboardGroups.length === 0 ? (
          <Empty />
        ) : (
          <ResourcesTable
            context={Context.FROM_GROUP_RESOURCES}
            editMode={isOwner || isAdmin}
            items={resources}
            onClickItemUnlink={(_, resource) => handleUnlink(resource)}
          />
        )}
      </GroupTemplate>

      {/*-- dialogs --*/}

      <UnlinkDialog
        open={dialog.open && dialog.variant === 'unlink'}
        onClose={handleCloseDialog}
        onUnlink={(done) => {
          if (group && dialog.data) {
            tryRevokeFromDashboard(dialog.data.id, {
              group_id: group?.id
            })
          }

          handleCloseDialog()
          done()
        }}
        source={group?.name ?? ''}
        title={dialog.data?.title ?? ''}
        type={t('global', 'resource')}
      />
    </>
  )
}

export default GroupResources
